/** @format */

import { useDispatch, useSelector } from 'react-redux';
import {
	loadingSelector,
	titleSelector,
	countriesSelector,
	citiesSelector,
	selectedCountrySelector,
	selectedCitiesSelector,
	meetupSelector,
	searchTitlesSelector,
	selectedTitleSelector
} from './selector';
import {
	setSelectedCountry,
	setSelectedCities,
	fetchCountries,
	fetchCities,
	fetchSelectedCountry,
	fetchFilterKeyWord,
	resetFilter,
	setTitle,
	fetchMeetups
} from './action';
import { useCallback } from 'react';

export const useFilter = () => {
	const dispatch = useDispatch();
	const loading = useSelector(loadingSelector);
	const title = useSelector(titleSelector);
	const countries = useSelector(countriesSelector);
	const cities = useSelector(citiesSelector);
	const selectedCountry = useSelector(selectedCountrySelector);
	const selectedCities = useSelector(selectedCitiesSelector);
	const meetups = useSelector(meetupSelector);
	const searchTitles = useSelector(searchTitlesSelector);
	const selectedTitle = useSelector(selectedTitleSelector);

	const boundSetTitle = useCallback((title) => dispatch(setTitle(title)), [
		dispatch
	]);
	const boundSetSelectedCountry = useCallback(
		(country) => dispatch(setSelectedCountry(country)),
		[dispatch]
	);
	const boundSetSelectedCities = useCallback(
		(cities) => dispatch(setSelectedCities(cities)),
		[dispatch]
	);
	const boundResetFilter = useCallback(() => dispatch(resetFilter()), [
		dispatch
	]);

	const boundFetchCountries = useCallback(() => dispatch(fetchCountries()), [
		dispatch
	]);

	const boundFetchCities = useCallback(() => dispatch(fetchCities()), [
		dispatch
	]);

	const boundFetchSelectedCountry = useCallback(
		(country) => dispatch(fetchSelectedCountry(country)),
		[dispatch]
	);

	const boundFetchFilterKeyWord = useCallback(
		() => dispatch(fetchFilterKeyWord()),
		[dispatch]
	);

	const boundFetchMeetups = useCallback(
		(params) => {
			dispatch(fetchMeetups(params));
		},
		[dispatch]
	);

	return {
		loading,
		searchTitles,
		title,
		countries,
		cities,
		selectedCountry,
		selectedCities,
		selectedTitle,
		meetups,
		boundSetSelectedCountry,
		boundSetSelectedCities,
		boundResetFilter,
		boundFetchCountries,
		boundFetchCities,
		boundFetchFilterKeyWord,
		boundFetchSelectedCountry,
		boundFetchMeetups,
		boundSetTitle
	};
};
